export type TPrivateInfo = {
	privateRoomChatId: string;
	privateStreamUrl: string;
	correlationId: string;
	isWithClientAudio: boolean;
	clientChatId: string;
	userId: string;
	userNickname: string;
	userAccountId: number;
	privateRequestId: number;
	privateModeStartedAt: number;
	balance: string;
	outerPrivate: boolean;
	isPromoParticipant: boolean;
	isWhale: boolean;
	tipperCategory: number;
	tipperColor: string;
	tipperCategoryDescription: string;
	remark: string;
};

export enum EBroadcastStatus {
	OFFLINE = "offline",
	PUBLIC = "public",
	PRIVATE = "private",
	AWAY = "away",
}

export type TGetBroadcastStatusResponse = {
	id: string;
	startedAt: number;
	isOnline: boolean;
	isAwayMode: boolean;
	broadcastAwayModeStatus: string;
	broadcastAwayModeStatusMessage: string;
	broadcastTextStatus: string;
	broadcastStatus: EBroadcastStatus;
	broadcastMembersCount: number;
	broadcastDurationSec: number;
	lastBroadcast: number;
	is2DStreamActive: boolean;
	is3DStreamActive: boolean;
	hasMask: boolean;
	privateInfo: TPrivateInfo | null;
};

export type TPostStartBroadcastResponse = {
	id: string;
	startedAt: string;
};

export type getBroadcastSettingsResponse = {
	id: string;
	stream2DKey: string;
	stream2DStatus: string;
	stream3DKey: string;
	stream3DStatus: string;
	streamUrl: string;
};
